<!-- eslint-disable vue/no-parsing-error -->
<template>
  <div class="template-box">
    <!-- 测试 -->
    <!-- <div class="aaa" @click="toZd">预约诊断</div> -->
    <div v-if="theme" class="theme">
      {{ theme }}
    </div>
    <div v-if="themeIntro" class="themeIntro">
      {{ themeIntro }}
    </div>
    <div class="sle-box">
      <span class="s1">Learning Center:</span>
      <span class="s2">
        <el-select
          v-model="learningCenter"
          :placeholder="'Please select'"
          :multiple="false"
          popper-class="normal-grace-dropdown-n"
          @change="handleGradeChange"
        >
          <el-option
            v-for="item in gradeList"
            :key="item.id"
            :value="item.venueName"
          >{{ item.venueName }}</el-option>
        </el-select>
      </span>
    </div>
    <div class="tab-box">
      <div
        class="class-tab"
        :class="{ on: changeClass == 1, long: classListNum == 1 }"
        @click="changeClassF(1)"
      >
        {{ classInfo.year + ' ' + classInfo.semesterLabel }}
      </div>
      <div
        v-if="classListNum == 2"
        class="class-tab"
        :class="{ on: changeClass == 2 }"
        @click="changeClassF(2)"
      >
        {{ classInfo2.year + ' ' + classInfo2.semesterLabel }}
      </div>
    </div>
    <div class="info-main">
      <div v-for="(item, index) in listNow" :key="index" class="class-lv2">
        <div
          class="lv2-card"
          :class="{ show: item.show }"
          @click="lv2Change(item)"
        >
          <span v-if="!item.loading" class="i1" />
          <div v-else class="i-loading-wrapper">
            <span class="i-loading" />
          </div>
          <span class="nj">{{ item.gradeLabel }}</span>
          <!-- <span
            v-if="item.link"
            class="btn-tc"
            @click.stop
            @click="toLink(item.link)"
          >Trial class</span> -->
        </div>
        <template v-if="item.show && item.lv3Date">
          <div v-for="item3 in item.lv3Date" :key="item3.key">
            <div
              class="nd-lv3"
              :class="{ show: item3.show }"
              @click="changeShow(item3)"
            >
              <div class="lv3-card">
                <span class="i2" />
                <span class="tag">{{ item3.levelDegreeName }}</span>
                <div class="star-box">
                  <span
                    v-for="(item, index3) in item3.star"
                    :key="index3"
                    class="star"
                  />
                </div>
                <!-- <div class="lnb-new">
                  <div v-if="item3.starDesc" class="lnb" @click.stop>
                    <span>{{ item3.starDesc }}</span>
                  </div><span class="lnb-txt">Difficulty Level</span>
                </div> -->
              </div>
              <div v-if="item3.show" class="info-lv4" @click.stop>
                <p class="lv4-title">
                  Start with evaluation and enroll now!
                </p>
                <div class="lv4-card">
                  <div class="lv4-th">
                    <div style="width: 255px;">
                      Date
                    </div>
                    <div style="width: 296px;">
                      Time
                    </div>
                    <div style="width: 160px;">
                      Teacher
                    </div>
                    <div style="width: 180px;">
                      Syllabus
                    </div>
                    <div style="flex: 1;">
                      Class Size
                    </div>
                  </div>
                  <div
                    v-for="item4 in item3.classList"
                    :key="item4.classId"
                    class="lv4-td"
                  >
                    <div style="width: 255px;">
                      {{
                        item4.startDate
                          | resourceDateFormate(timezone, dateFormat)
                      }}
                      -
                      {{
                        item4.endDate
                          | resourceDateFormate(timezone, dateFormat)
                      }}
                    </div>
                    <div style="width: 296px;">
                      {{ item4.timeDesc }}
                    </div>
                    <div style="width: 160px; word-break: break-word;">
                      <span
                        v-for="teacherItem in item4.teacherList"
                        :key="teacherItem.id"
                        class="link"
                        @click="toTeacher(teacherItem.id)"
                      >{{ teacherItem.name }}</span>
                    </div>
                    <div style="width: 180px;">
                      <span class="link" @click="showPop(item4.syllabus)">View syllabus</span>
                    </div>
                    <div style="width: 160px; display: flex; align-items: center;">
                      <!-- {{ item4.sellStore }}/ -->
                      <span style="width: 30px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">{{ item4.store }}</span>
                      <div v-if="item4.sellStore === item4.store" class="classType full">
                        Full
                      </div>
                      <div v-else-if="(item4.store - item4.sellStore) <= Math.ceil(item4.store / 3)" class="classType">
                        {{ item4.store-item4.sellStore }} Left
                      </div>
                    </div>
                    <div style="flex: 1;">
                      <span
                        v-if="item4.sellStore == item4.store || !item4.onSell"
                        class="lv4-btn full"
                      >Enroll</span>
                      <span v-else class="lv4-btn" @click="handleEnroll(item4)">Enroll</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div v-if="popBoxShow" class="pop-box">
      <div class="bg" />
      <div class="main">
        <div class="pop-title">
          Syllabus and Schedule<span @click="closePop" />
        </div>
        <div class="pop-info">
          <div
            v-for="(item, index) in syllabusList"
            :key="index"
            class="pop-info-list"
          >
            <span class="s1">{{
              index + 1 < 10 ? "0" + (index + 1) : index + 1
            }}</span>
            <div class="s2">
              <p class="p1">
                {{ item.timeDesc }}
              </p>
              <p class="p2">
                {{ item.name }}
              </p>
            </div>
            <span v-if="item.isStarted === 0 && $store.state.locale !== 'us'" class="s3">Started</span>
            <span v-if="item.isStarted === 0 && $store.state.locale === 'us'" class="s3">Completed</span>
          </div>
        </div>
      </div>
    </div>
    <!-- <div v-if="loading" class="loading-box">
      <div class="loading-icon">
        <span />
      </div>
    </div> -->

    <ConfirmDialog
      :show.sync="confirmDialogConfig.show"
      :title="confirmDialogConfig.title"
      :content="confirmDialogConfig.content"
      :sub-btn-text="confirmDialogConfig.subBtnText"
      :main-btn-text="confirmDialogConfig.mainBtnText"
      @subBtnClick="confirmDialogConfig.subBtnClick"
      @mainBtnClick="confirmDialogConfig.mainBtnClick"
    />
    <EvaluationDialog
      :evaluation-dialog-info="evaluationDialogInfo"
      :show.sync="showEvaluationDialog"
      :detail-data="detailData"
    />
    <SwitchStudentDialog
      ref="coursesDetailSwitchStudentDialog"
      :is-appli="true"
      switch-stu-tip-text=""
      @switch-success="switchSuccessHandler"
    />
  </div>
</template>

<script>
import mixin from './mixin';
import ConfirmDialog from '@/components/web/common/ConfirmDialog/index.vue';
import EvaluationDialog from '@/components/web/courses/EvaluationDialog';
import SwitchStudentDialog from '@/components/web/courses/SwitchStudentDialog';

export default {
  components: {
    ConfirmDialog,
    EvaluationDialog,
    SwitchStudentDialog,
  },
  mixins: [mixin],
  data() {
    return {};
  },
  methods: {
    // toZd() {
    //   console.log("触发预约登录弹窗");
    //   bus.$emit("toShowDiagnosis", { type: 1 });
    // },
  },
};
</script>

<style lang="scss" scoped>

.el-select-dropdown {
  .el-select-dropdown__item:first-child {
    margin-left: 4px;
    margin-right: 4px;
  }
  .el-select-dropdown__item + .el-select-dropdown__item {
    margin-top: 5px;
    margin-left: 4px;
    margin-right: 4px;
  }
  .el-select-dropdown__item:last-child {
    margin-bottom: 0;
  }
  .el-select-dropdown__item {
    text-align: left;
    font-family: Roboto-Flex, sans-serif;
    font-size: 22px;
    font-weight: 500;
    color: var(--txt-color-lv4);
    height: 50px;
    line-height: 50px;
    //margin: 0 4px 5px 4px;

    &.selected {
      font-weight: normal;
      background: #fff;
      //color: #ff9f0a;
    }

    &:hover {
      background: rgba(255, 159, 10, 0.1);
      color: #ff9f0a;
    }
  }

}
.template-box {
  width: 1240px;
  margin: 0 auto 0;

  .theme {
    width: 1080px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 40px;
    font-family: Roboto-Flex, sans-serif;
    font-weight: bold;
    color: var(--txt-color-lv4);
    //line-height: 24px;
    text-align: center;
    margin: 0 auto 20px;
  }

  .themeIntro {
    font-size: 18px;
    font-family: Roboto-Flex, sans-serif;
    font-weight: 500;
    color: var(--txt-color-lv4);
    line-height: 14px;
    text-align: center;
    margin-bottom: 20px;
  }

  .sle-box {
    display: flex;
    line-height: 42px;
    align-items: center;

    select {
      width: 100%;
      height: 51px;
      line-height: 32px;
      background: #fff;
      border-radius: 4px;
      border: 1px solid #222;
      opacity: 0.1;
      //padding: 0 10px;
    }

    .s2 {
      width: 400px;

      ::v-deep .el-select {
        width: 505px;
      }

      ::v-deep .el-input__inner {
        font-family: Roboto-Flex, sans-serif;
        font-size: 22px;
        font-weight: 500;
        color: #222;
        height: 51px;
        opacity: 0.5;
        line-height: 34px;
        padding-left: 20px;
      }
    }

    .s1 {
      font-size: 22px;
      font-family: Roboto-Flex, sans-serif;
      font-weight: 600;
      line-height: 34px;
      text-align: left;
      color: var(--txt-color-lv4);
      width: 174px;
      margin-right: 20px;
    }
  }

  .tab-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    // border-radius: 16px 16px 0px 0px;
    height: 60px;
    overflow: hidden;
    margin-top: 20px;
    margin-bottom: 16px;

    .class-tab {
      border: 1px solid #ff9f0a;
      width: 610px;
      height: 60px;
      line-height: 60px;
      text-align: center;
      font-size: 22px;
      font-family: Roboto-Flex, sans-serif;
      font-weight: bold;
      color: #ff9f0a;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding: 0 10px;
      background: #fff;
      cursor: pointer;

      &:hover {
        background: #fafafa;
      }

      &.long {
        width: 100%;
      }

      &.on {
        font-size: 22px;
        font-family: Roboto-Flex, sans-serif;
        font-weight: bold;
        color: #fff;
        background: #ff9f0a;

        &:hover {
          background: #e58e08;
          color: #fff;
        }
      }
    }
  }

  .class-lv2 {
    margin-bottom: 8px;

    .lv2-card {
      height: 60px;
      background: #ffa827;
      display: flex;
      align-items: center;
      justify-content: center;

      &.show .i1 {
        // background: url("https://download-pa-s3.thethinkacademy.com/message/picture/8601/20240612/1718182599495diWeRUMp6g.png")
        //   0 0/ 100% auto no-repeat;
        background: url('~assets/images/courses/icon-course-retract.png') 0 0/ 100% auto no-repeat;
      }

      .i1 {
        width: 30px;
        height: 30px;
        // background: url("https://download-pa-s3.thethinkacademy.com/message/picture/8601/20240612/1718180524182jAQUfux9cd.png")
        //   0 0/ 100% auto no-repeat;
        background: url('~assets/images/courses/icon-course-expand.png') 0 0/ 100% auto no-repeat;
        margin: 0 20px;
        cursor: pointer;
      }

      .i-loading-wrapper {
        width: 30px;
        height: 30px;
        background: #fff;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 20px;
      }

      .i-loading {
        width: 15px;
        height: 15px;
        // background: url("https://download-pa-s3.thethinkacademy.com/message/picture/8601/20240611/1718078524252kWEE0i98ry.png")
        //   0 0/ 100% auto no-repeat;
        background: url('~assets/images/courses/icon-loading.png') 0 0/ 100% auto no-repeat;
        animation: round 1s linear infinite;
      }

      .nj {
        flex: 1;
        font-size: 22px;
        font-family: Roboto-Flex, sans-serif;
        font-weight: bold;
        color: #fff;
        line-height: 60px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .btn-tc {
        width: 120px;
        height: 48px;
        background: #fff;
        border-radius: 25px;
        text-align: center;
        font-size: 18px;
        font-family: Roboto-Flex, sans-serif;
        font-weight: 600;
        color: var(--txt-color-link);
        line-height: 48px;
        margin-right: 20px;
        cursor: pointer;
      }
    }
  }

  .nd-lv3 {
    margin-bottom: 4px;

    &.show {
      border: 1px solid #ff9f0a;
      margin-bottom: 26px;

      .lv3-card .i2 {
        // background: url("https://download-pa-s3.thethinkacademy.com/message/picture/8601/20240612/1718182634193qiNQeCEbyl.png")
        //   0 0/ 100% auto no-repeat;
        background: url('~assets/images/courses/icon-course-retract.png') 0 0/ 100% auto no-repeat;
      }
    }

    .lv3-card {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      height: 60px;
      background: rgba(255, 168, 39, 0.1);

      .i2 {
        width: 30px;
        height: 30px;
        // background: url("https://download-pa-s3.thethinkacademy.com/message/picture/8601/20240612/1718182816138cXrXFIOfiW.png")
        //   0 0/ 100% auto no-repeat;
        background: url('~assets/images/courses/icon-course-expand.png') 0 0/ 100% auto no-repeat;
        margin: 0 20px;
        cursor: pointer;
      }

      .tag {
        height: 24px;
        font-size: 22px;
        font-family: Roboto-Flex, sans-serif;
        font-weight: 600;
        color: #ff9f0a;
        margin-right: 31px;
        line-height: 24px;
      }

      .star-box {
        display: flex;

        .star {
          width: 24px;
          height: 24px;
          margin-right: 17px;
          background:
            url("https://download-pa-s3.thethinkacademy.com/message/picture/8601/20240612/1718182926058Ee3k2SBntS.png")
            0 0/ 100% auto no-repeat;
        }
      }

      .lnb-new {
        height: 30px;
        line-height: 30px;
        padding: 0 10px;
        background: #fff;
        border-radius: 4px;
        margin-top: 1px;

        .lnb-txt {
          font-size: 18px;
          font-family: Roboto-Flex, sans-serif;
          font-weight: 600;
          color: var(--txt-color-link);
        }
      }

      .lnb {
        display: inline-block;
        vertical-align: top;
        margin: 6px 8px 0 0;
        position: relative;
        width: 16px;
        height: 16px;
        cursor: pointer;
        background:
          url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAyNJREFUWEfNl0+IFnUYxz/fmY3Xd9YovOx2CaOsg4QkRUInT0L+gQpExX3dWaUoREqhDoFtQgc9mCCIiOu7f0LDgwfLg5eiQ1AEhYRBmChdWhcRxX3n3decedx5591t1n/zzrzKNqeB+T3P85nf81+0+dgQT6LyGqSVwDLgOeCplvgN4BJwDrPvsfq32srNdlQr65BVS0vA/QRsI8gDxoFfMPsLdD2Rt6eRXgBeA3rBAtAJCPfKb1x4mI0HAliVBVDeM23kQ7Ap5AwhG9WW4LeHKbQR7xVMFSzaClowDXcA6rvlM3U/ufsC2HDpecw9BSzF4RD/BoPaxrWs20p/t6Msosv7HON94DwK31Z/4+LdOu4BsLHuZdy2s0AJVxtUqcXvhR8b7V5FaF8DDbq0Sn21c2llcwBaf/4j2CRd0Wr1Nf4sbDklaGOll7jtnAEtROEb6ZuYBUh87v0MPEtXuKId4zbqvUqohvza71mgCYT7E/A3BK/PxEQKoLwPtBNXq9u5dqt6A8AQECHeUn9wOhMicccZsP3y6x/H55sArVQ7j8NhbQl2ZClqygx7BzG2N8+Kz9Qf7Mkh9x6ES+MUbQF4R8HWE9YXtxvtSbw4o4g6rvrUF/zTFkCcHW75Muik/GCbmhXOKY8j54j6ax+1o6TTMzbc/SUWvUtU75UdK29EOo7D8qwi06nhGflmsYr4FbNNsqp3BFgrP3gmrwGrdr8M4U35U5fzy3qxy76JAeLUuyI/WJdHiY2UXiRy/8CYpDfo0Zs0cslXvThremKACbAx+fVduRSMLFxJFH3XlHGdHlUmJ3LJHyvvR9ocAzQwvtBAe2n0nx87BfB2Iz79XwBMYPaVBuo7c13hI3RBwSDs0AWpICyUhtbxDXjjiNOFC1EnAHMLUcFS3BFAuhQn3bBAMyroguaolm5GhdtxUYCkjc9txwlEzoFkpqHALdxgkSrUstK4NR/eO5AkAAVGsuHyOzh2VZWpHzKNZ41kyZTTHMfnZyidrfHzOZbPQjyqxeQJb5CID3ItJrMQ87mapQPqgcspdgFTvBU/nuX07qh+XOv5HbpQClt9nECfAAAAAElFTkSuQmCC")
          0 0/ 100% auto no-repeat;

        span {
          // width: 290px;
          min-height: 32px;
          background: #fff;
          box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.06);
          padding: 8px;
          position: absolute;
          font-size: 14px;
          font-family: Roboto-Flex, sans-serif;
          font-weight: 500;
          color: #222;
          line-height: 16px;
          top: 28px;
          left: -10px;
          z-index: 2;
          display: none;
          width: auto;
          white-space: nowrap;
        }

        &:hover {
          span {
            display: block;
          }
        }
      }
    }
  }

  .info-lv4 {
    padding: 30px 20px 0;

    .lv4-title {
      font-size: 22px;
      font-family: Roboto-Flex, sans-serif;
      margin-left: 20px;
      font-weight: 600;
      color: var(--txt-color-lv4);
      opacity: 60%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      line-height: 24px;
    }

    .lv4-card {
      margin-top: 20px;

      .lv4-th {
        display: flex;
        align-items: center;
        height: 50px;
        background: #f9f9f9;
        border-radius: 4px;
        font-size: 22px;
        font-family: Roboto-Flex, sans-serif;
        font-weight: 600;
        color: var(--txt-color-lv4);
        line-height: 18px;
        padding-left: 20px;
      }

      .lv4-td {
        border-bottom: 1px solid #f1f1f1;
        display: flex;
        align-items: center;
        min-height: 70px;
        font-size: 18px;
        font-family: Roboto-Flex, sans-serif;
        font-weight: 500;
        color: var(--txt-color-lv4);
        line-height: 22px;
        padding: 10px 20px 10px 0;

        div {
          padding-left: 20px;
        }

        .link {
          color: #ff9f0a;
          text-decoration: underline;
          cursor: pointer;
          display: inline-block;
          margin-right: 10px;

          &:hover {
            text-decoration: none;
          }
        }

        .lv4-btn {
          width: 82px;
          height: 30px;
          background: #ff9f0a;
          border-radius: 18px;
          line-height: 30px;
          font-size: 18px;
          font-family: Roboto-Flex, sans-serif;
          font-weight: 600;
          color: #fff;
          cursor: pointer;
          text-align: center;
          display: inline-block;

          &:hover {
            background: #e58e08;
          }

          &.full {
            // opacity: 0.4;
            background: #adadad;
            cursor: no-drop;
          }
        }

        .classType {
          font-size: 16px;
          font-family: Roboto-Flex, sans-serif;
          font-weight: 500;
          height: 26px;
          text-align: center;
          line-height: 26px;
          display: inline-block;
          margin-left: 4px;
          background: #eaf1ff;
          border-radius: 12px;
          color: #3071ff;
          padding: 1px 11px;

          &.full {
            color: #ff5464;
            background: #ffeeef;
          }
        }
      }
    }
  }

  .pop-box {
    position: fixed;
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;
    z-index: 9999;

    .bg {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      background: rgba(0, 0, 0, 0.6);
    }

    .main {
      position: absolute;
      height: 600px;
      width: 600px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }

    .pop-title {
      height: 60px;
      background: #fff;
      border-radius: 10px;
      line-height: 60px;
      text-align: center;
      font-size: 22px;
      font-family: Roboto-Flex, sans-serif;
      font-weight: bold;
      color: #222;
      position: relative;
      margin-bottom: 2px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;

      span {
        position: absolute;
        width: 32px;
        height: 32px;
        top: 14px;
        right: 16px;
        background:
          url("https://download-pa-s3.thethinkacademy.com/message/picture/8601/20240612/17181830757532OIpiJY5mI.png")
          0 0/ 100% auto no-repeat;
      }
    }

    .pop-info {
      height: 538px;
      background: #f4f6fa;
      border-radius: 10px;
      padding: 16px 16px 0;
      overflow: hidden;
      overflow-y: auto;

      .pop-info-list {
        margin-bottom: 16px;
        height: 68px;
        background: #fff;
        border-radius: 10px;
        display: flex;
        align-items: center;
        position: relative;

        .s1 {
          position: absolute;
          left: -5px;
          top: 15px;
          font-size: 14px;
          font-family: Montserrat-Bold, Montserrat;
          font-weight: bold;
          color: #fff;
          width: 26px;
          height: 38px;
          line-height: 38px;
          text-align: center;
          background:
            url("https://download-pa-s3.thethinkacademy.com/message/picture/8601/20240612/17181806736994JtRbY66uM.png")
            0 0/ 100% auto no-repeat;
        }

        .s2 {
          padding: 0 10px 0 40px;
          flex: 1;
          width: 0;

          .p1 {
            font-size: 14px;
            font-family: Montserrat-Medium, Montserrat;
            font-weight: 500;
            color: #a2aab8;
            line-height: 18px;
          }

          .p2 {
            font-size: 18px;
            font-family: Montserrat-SemiBold, Montserrat;
            font-weight: 600;
            color: #172b4d;
            line-height: 24px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }

        .s3 {
          width: 82px;
          height: 32px;
          background: #f4f6f9;
          border-radius: 16px;
          font-size: 14px;
          font-family: PingFangTC-Semibold, PingFangTC;
          font-weight: 600;
          color: #172b4d;
          line-height: 32px;
          text-align: center;
          margin-right: 16px;
        }
      }
    }
  }
}

.loading-box {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 20;
  left: 0;
  top: 0;
  // background: rgba(244, 246, 250, 0.8);
  .loading-icon {
    text-align: center;
    position: absolute;
    padding: 15px;
    background: var(--txt-color-link);
    box-shadow: 0 0 18px 0 rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    span {
      width: 30px;
      height: 30px;
      display: inline-block;
      background: url(data:image/png;base64,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);
      background-size: 30px 30px;
      animation: round 1s linear infinite;
    }

    p {
      color: rgba(162, 170, 184, 1);
    }
  }
}

@keyframes round {
  to {
    transform: rotate(360deg);
  }
}
</style>
<style>
.normal-grace-dropdown-n {
  width: 400px;
}
</style>
